import { io } from "socket.io-client";

let socket = null;

export const connectSocket = (token) => {
    if (socket?.connected) {
        return socket;
    }
    const BE_URL = process.env.REACT_APP_BASE_URL;
    console.log("BE_URL=",BE_URL)
    socket = io(`${BE_URL}`, {
        transports: ["websocket"],
        auth: {
            token: "HungKK",
        },
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
    });

    socket.on("connect", () => {
        console.log("Socket connected:", socket.id);
    });

    socket.on("disconnect", (reason) => {
        console.log("Socket disconnected:", reason);
    });

    socket.on("connect_error", (err) => {
        console.log("Socket error:", err.message);
    });

    return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};